/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeTableCategoryCell } from "../../d-table-category-cell";
import { DThemeDarkTableHeaderCell } from "./d-theme-dark-table-header-cell";

export class DThemeDarkTableCategoryCell
	extends DThemeDarkTableHeaderCell
	implements DThemeTableCategoryCell {}
